import { Direction } from "../AxDropdown";
import i18next from '../../i18n';
export class AxDropdownInteraction {
    constructor(options) {
        this.options = options;
    }
    getTippyInstance($parent) {
        //@ts-ignore
        const instance = $parent[0]._tippy;
        return instance;
    }
    open($target) {
        let instance = this.getTippyInstance($target);
        instance.show();
    }
    close($target) {
        let instance = this.getTippyInstance($target);
        instance.hide();
    }
    afterOpen($parent, $popperElem) {
        $popperElem
            .children(".ax-dropdown__search")
            .children(".ax-dropdown__search-input")
            .focus();
        this.openSubject.next(true);
        if (this.options.onOpen != null) {
            this.options.onOpen($parent);
        }
    }
    afterOnShown($parent, $popperElem) {
        // $popperElem
        //     .children(".ax-dropdown__search")
        //     .children(".ax-dropdown__search-input")
        //     .focus();
        this.onShownSubject.next(true);
        if (this.options.onOpened != null) {
            this.options.onOpened($parent);
        }
    }
    search($target, $parent, $popperElem) {
        let isHero = $parent.hasClass('ax-dropdown--hero');
        let value = $target.val();
        if (isHero) {
            $parent.find('.ax-dropdown__selection').toggleClass('d-none', value != '');
        }
        let results = 0;
        $(".ax-dropdown__menu .ax-dropdown__item:not(.ax-dropdown__search):not(.noresults)", $popperElem).each(function (index) {
            $(this).hide();
            if ($(this).is(':contains("' + value + '")')) {
                $(this).show();
                results = 1;
            }
        });
        if (results == 0) {
            if (!$(".noresults", $popperElem).length) {
                $(".ax-dropdown__menu", $popperElem).append(`<li class="noresults ax-dropdown__item">${i18next.t('dropdown.noresult')}</li>`);
            }
        }
        else {
            $(".noresults", $popperElem).remove();
        }
    }
    select($target, $parent) {
        const hasMultiSelect = this.hasMultiSelectClass($parent);
        const tippyInstance = this.getTippyInstance($parent);
        const popperInstance = tippyInstance.popperInstance;
        const currentValue = this.getValue($parent);
        if ($target.is("[disabled]")) {
            return;
        }
        if (hasMultiSelect) {
            this.selectMulti($target, $parent);
            popperInstance === null || popperInstance === void 0 ? void 0 : popperInstance.update();
        }
        else {
            this.selectSingle($target, $parent);
            tippyInstance === null || tippyInstance === void 0 ? void 0 : tippyInstance.hide();
        }
        let value = this.getValue($parent);
        this.changeSubject.next(value);
        if (this.options.onSelect != null) {
            this.options.onSelect($parent, value);
        }
        if (this.options.onChange != null) {
            if (currentValue != null && !hasMultiSelect) {
                this.options.onChange($parent, currentValue, Direction.removed, value);
            }
            this.options.onChange($parent, $target.attr('data-value'), Direction.added, value);
        }
    }
    getValue($parent) {
        var _a, _b;
        const tippyInstance = this.getTippyInstance($parent);
        const $popperElement = $(tippyInstance.popper);
        if (!this.hasMultiSelectClass($parent)) {
            return (_b = (_a = $popperElement.find('.ax-dropdown__menu .ax-dropdown__item.selected')) === null || _a === void 0 ? void 0 : _a.attr('data-value')) !== null && _b !== void 0 ? _b : null;
        }
        let retVal = [];
        for (let elem of $popperElement.find('.ax-dropdown__menu .ax-dropdown__item.selected')) {
            retVal.push($(elem).attr('data-value'));
        }
        return retVal;
    }
    setValue(value, $parent) {
        const currentValue = this.getValue($parent);
        const isMultiSelect = this.hasMultiSelectClass($parent);
        const $selection = this.getOptionByValue(value, $parent);
        if ($selection.length === 0) {
            $parent.find(".ax-dropdown__trigger").addClass("has-selection");
            $parent.find(".ax-dropdown__trigger .ax-dropdown__selection").text(value);
            $parent.find(".hidden-input").val(value).addClass("value");
            return;
        }
        if ($selection.is("[disabled]")) {
            return;
        }
        if (isMultiSelect) {
            this.selectMulti($selection, $parent);
        }
        else {
            this.selectSingle($selection, $parent);
        }
        if (this.options.onSelect != null) {
            this.options.onSelect($parent, value);
        }
        if (this.options.onChange != null) {
            if (currentValue != null && !isMultiSelect) {
                this.options.onChange($parent, currentValue, Direction.removed, value);
            }
            this.options.onChange($parent, value, Direction.added, this.getValue($parent));
        }
    }
    resetSelection($parent) {
        const value = this.getValue($parent);
        const tippyInstance = this.getTippyInstance($parent);
        const $popperElement = $(tippyInstance.popper);
        $parent.find(".ax-dropdown__trigger").removeClass("active");
        $parent.find(".ax-dropdown__trigger").removeClass("has-selection");
        $parent.find(".ax-dropdown__trigger .ax-dropdown__selection").text('');
        $popperElement.find('.ax-dropdown__menu .ax-dropdown__item').removeClass('selected');
        $parent.find(".hidden-input").val('').removeClass("value");
        if (this.options.onChange != null) {
            if (this.hasMultiSelectClass($parent)) {
                for (let val of value) {
                    this.options.onChange($parent, val, Direction.removed, []);
                }
            }
            else {
                this.options.onChange($parent, value, Direction.added, null);
            }
        }
    }
    hasMultiSelectClass($parent) {
        return $parent.hasClass('ax-dropdown--multiselect');
    }
    toggleDisabled(option, disabled, $parent) {
        let $option;
        if (typeof option === 'string') {
            $option = this.getOptionByValue(option, $parent);
        }
        else {
            $option = option;
        }
        let newValue = disabled;
        if (typeof disabled == 'undefined' || disabled == null) {
            var existingAttr = $option.attr('disabled');
            newValue = (typeof existingAttr == undefined || existingAttr == null);
        }
        if (newValue) {
            $option.attr('disabled', 'disabled');
        }
        else {
            $option.removeAttr('disabled');
        }
        $option.prop('disabled', disabled);
        return newValue;
    }
    getOptionByValue(value, $parent) {
        const tippyInstance = this.getTippyInstance($parent);
        const $popperElement = $(tippyInstance.popper);
        return $popperElement.find(`.ax-dropdown__menu .ax-dropdown__item[data-value="${value}"]`);
    }
    selectSingle($target, $parent) {
        var _a;
        const $singleTarget = $($target[0]);
        const lineText = $singleTarget.text();
        $singleTarget.addClass("selected").siblings().removeClass("selected");
        $singleTarget.parent(".ax-dropdown__menu").hide();
        $parent.find(".ax-dropdown__trigger").addClass("has-selection");
        $parent.find(".ax-dropdown__trigger .ax-dropdown__selection").text(lineText);
        $parent.find(".hidden-input").val((_a = $singleTarget.attr('data-value')) !== null && _a !== void 0 ? _a : lineText).addClass("value");
        $parent.find(".ax-dropdown__trigger").removeClass("active");
        const $hero = $singleTarget.parents(".ax-dropdown--hero").find(".ax-dropdown__trigger");
        if ($hero.hasClass("has-selection")) {
            if ($hero.find($(".ax-dropdown--reset")).length === 0) {
                $hero.append('<i class="la la-times-circle ax-dropdown--reset"></i>');
            }
        }
        if ($parent.find(".ax-dropdown__trigger").hasClass("has-selection")) {
            $parent.find(".ax-dropdown__trigger").removeClass("has-error");
            $parent.parent(".ax-form-group").find("label.field-error").hide();
        }
        if ($parent.find(".ax-form-group input").hasClass("value")) {
            $parent
                .find(".ax-form-group input")
                .removeClass("field-error");
        }
        $singleTarget
            .siblings(".ax-dropdown__search")
            .children(".ax-dropdown__search-input")
            .val("");
    }
    selectMulti($target, $parent) {
        const lineText = $target.text();
        const $newLabel = $('<div class="ax-dropdown__multi-label">' +
            lineText +
            '<a href="#" class="ax-dropdown__muli-remove"></a></div>');
        $target.each((i, elem) => {
            const $elem = $(elem);
            const items = $elem.data("value");
            const $existingLabel = $parent.find(`.ax-dropdown__multi-label[data-value="${items}"]`);
            if ($existingLabel.length === 0) {
                $parent
                    .find(".ax-dropdown__trigger .ax-dropdown__selection")
                    .append($newLabel.attr("data-value", items));
            }
            else {
                $existingLabel.remove();
            }
        });
        $target.toggleClass('selected');
        $target
            .siblings(".ax-dropdown__search")
            .children(".ax-dropdown__search-input")
            .val("");
        $parent.find(".ax-dropdown__trigger").toggleClass("has-selection", $parent.find(".ax-dropdown__selection").children(".ax-dropdown__multi-label").length > 0);
        //$parent[0]._tippy.popperInstance.update();
    }
    deleteMultiSelection($parent, targetId, $popperElem) {
        const $label = $popperElem.find(".ax-dropdown__menu .ax-dropdown__item");
        const $target = $popperElem.find(`.ax-dropdown__menu .ax-dropdown__item[data-value="${targetId}"]`);
        const targetSelected = $target.hasClass("selected");
        $target.removeClass("selected");
        $parent.find(`.ax-dropdown__multi-label[data-value="${targetId}"]`).remove();
        $label.each(() => {
            if (!$popperElem.find(".ax-dropdown__menu .ax-dropdown__item")
                .hasClass("selected")) {
                $parent.find(".ax-dropdown__trigger")
                    .removeClass("has-selection");
            }
        });
        if (targetSelected && this.options.onChange != null) {
            this.options.onChange($parent, targetId, Direction.removed, this.getValue($parent));
        }
    }
}
